<template>
    <div>
        <div class="flex justify-center">
            <h1 class="text-3xl">Subir y registrar archivo</h1>
        </div>
        <div id="info-container" class="flex flex-wrap">
            <div class="w-8/12"></div>
            <div
                class="lg:w-4/12 w-full mt-2 flex items-center justify-between"
            >
                <small for="swDateBetween">
                    ¿ Necesitas ayuda para crear las archivos ?
                </small>
                <app-button
                    icon
                    border
                    :active="enableHelp"
                    @click="enableHelp = !enableHelp"
                >
                    ℹ️
                </app-button>
            </div>
        </div>
        <process-guide
            v-model="enableHelp"
            title="¿Cómo subir y registrar un archivo?"
            :steps="[
                'Llena el formulario con los datos del archivo.',
                'Haz clic en el botón con el ícono de carga (⬆️).',
                'Selecciona el archivo, verificando que tenga las dimensiones adecuadas según su tipo.',
                'Confirma la carga cuando el sistema te pregunte. Si cargaste el archivo equivocado, contacta al administrador.',
                'Cuando el archivo se haya cargado correctamente, se habilitará el botón Crear archivo: verifica los datos y haz clic en él.'
            ]"
        />
        <div class="flex flex-col lg:flex-row justify-center items-center">
            <custom-radio
                v-for="(value, key) in $data.$typesFiles"
                :key="key"
                v-model="type"
                class="mt-1 mx-1"
                :disabled="!!file.id"
                :val="key"
            >
                <small>
                    {{ value }}
                </small>
            </custom-radio>
        </div>
        <div class="flex flex-wrap">
            <file-uploader
                v-model="file"
                :type="type"
                required-alt
                auto-loader
                @loading="onLoading"
                @created="onCreated"
            />
        </div>
        <div class="flex justify-center mt-3">
            <app-button
                gradient
                :active="!!file.id"
                :disabled="!file.id || isLoading"
                size="large"
                @click="createFileComponent"
            >
                Crear archivo
            </app-button>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import { typesFiles } from "@/common/fields/type-files";

import FileUploader from "@/components/utils/FileUploader.vue";
import ProcessGuide from "@/components/utils/ProcessGuide.vue";

export default {
    name: "FilesNew",
    components: {
        FileUploader,
        ProcessGuide
    },
    data: () => ({
        id: 0,
        enableHelp: false,
        isLoading: false,
        file: { id: null, name: "", url: "" },
        $typesFiles: typesFiles,
        type: "productFile"
    }),
    computed: {
        ...mapGetters("control", ["backgroundColor"])
    },
    watch: {},
    async mounted() {
        const verifyPagePermission =
            this.$ability.verifyPagePermission.bind(this);
        await verifyPagePermission("file:Create", "/app");
    },
    methods: {
        ...mapActions("files", ["uploadFile", "createFile"]),
        async createFileComponent() {
            this.isLoading = true;
            this.$loading.show();
            try {
                const result = await this.createFile({
                    ...this.file
                });
                this.$loading.hide();
                this.isLoading = false;
                this.$sound.play();
                const dialogResult = await this.$swal.fire({
                    background: this.backgroundColor,
                    title: "Deseas continuar subiendo archivos ?",
                    text: `Creada con el ID: ${result.id}`,
                    icon: "success",
                    showClass: {
                        popup: "animate__animated animate__fadeInDown"
                    },
                    hideClass: {
                        popup: "animate__animated animate__fadeOutUp"
                    },
                    showCancelButton: true,
                    focusConfirm: false,
                    confirmButtonText: "Si",
                    cancelButtonText: "Quiero regresar",
                    confirmButtonColor: "#02672D",
                    cancelButtonColor: "#113ea2",
                    allowOutsideClick: false,
                    showCloseButton: true
                });
                if (!dialogResult.isConfirmed) {
                    this.$router.push("/app/files");
                }
                this.file = {
                    id: 0,
                    name: "undefined",
                    type: "productFile",
                    url: ""
                };
            } catch (error) {
                this.$loading.hide();
                this.$sound.play("error");
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        },
        onLoading(value) {
            this.isLoading = value;
        },
        onCreated() {
            this.isLoading = false;
        }
    }
};
</script>
